import { render } from "./reports.vue?vue&type=template&id=b9f96324&scoped=true"
import script from "./reports.vue?vue&type=script&lang=js"
export * from "./reports.vue?vue&type=script&lang=js"

import "./reports.vue?vue&type=style&index=0&id=b9f96324&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f96324"]])

export default __exports__